import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import nl from '~/assets/translations/nl.json';
import en from '~/assets/translations/en.json';

i18n
	.use(initReactI18next)
	.init({
		resources: {
			nl: { translation: nl },
			en: { translation: en },
		},
		lng: 'nl',
		fallbackLng: 'en',
		interpolation: { escapeValue: false },
	})
	.catch((err) => console.error(err));

// dayjs writes its own month names; the app is Dutch, so its dates are too.
dayjs.locale('nl');

export const t = i18n.t.bind(i18n);
export default i18n;
